import { render, staticRenderFns } from "./UptoDatePage.vue?vue&type=template&id=25b3b445&scoped=true"
import script from "./UptoDatePage.vue?vue&type=script&lang=js"
export * from "./UptoDatePage.vue?vue&type=script&lang=js"
import style0 from "./UptoDatePage.vue?vue&type=style&index=0&id=25b3b445&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25b3b445",
  null
  
)

export default component.exports